import type { FC } from 'react';

import { DeliveryInfoTemplate } from '@/modules/perseo-billing/containers/payment-complete/components/purchase-detail/deliveries';
import type { TIntangibleDelivery } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import type { IconTypes } from '@/modules/perseo-billing/ui/react/src/components/beta';
import { Typography } from '@/modules/perseo-billing/ui/react/src/components/beta';
import { useCustomerContext } from '@/sections/customer/CustomerContext';

type DeliveryIntangibleInfoProps = {
  delivery: TIntangibleDelivery;
  deliveryIcon: IconTypes;
};

export const DeliveryIntangibleInfo: FC<DeliveryIntangibleInfoProps> = ({
  delivery,
  deliveryIcon
}) => {
  const { customer } = useCustomerContext();
  const fallbackEmail = customer?.data?.email ?? '';

  const { customerEmail: email = fallbackEmail } = delivery;

  const additionalInfo = (
    <div className="co-flex co-flex-col co-gap-4px co-px-16px">
      <Typography size="body2" weight="semibold">
        {'Mi correo electrónico:'}
      </Typography>
      <Typography size="body2">{email}</Typography>
    </div>
  );

  return (
    <DeliveryInfoTemplate
      deliveryIcon={deliveryIcon}
      title={'Entrega por correo'}
      additionalInfo={additionalInfo}
    >
      <Typography
        size="body2"
        weight="medium"
        className="co-text-[#485760]"
        leading="16px"
      >
        {
          'Te enviamos un correo con tu producto o la información para agendar el servicio.  Si no lo encuentras, busca en el buzón de correo no deseado.'
        }
      </Typography>
    </DeliveryInfoTemplate>
  );
};

DeliveryIntangibleInfo.displayName = 'DeliveryIntangibleInfo';

export default DeliveryIntangibleInfo;
